import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import { Webhook } from '../../models/webhook.model';

export class webhooksTableRowController implements IController {

  webhook: Webhook;
  webhookId: string;
  onRemove: Function;
  onEdit: Function;

  /* @ngInject */
  constructor(private $webhooks, private $scope: IScope) {}

  $onInit() {
    if (_.get(this.webhook, 'id')) {
      this.$webhooks(this.webhookId).$bindCtrlToId(this.$scope, this, 'webhook', 'webhookId');
    }
  }

  $onChanges(changes) {
    if (changes.webhookId && !changes.webhookId.isFirstChange()) {
      this.$onInit();
    }
  }

  onOpen($mdMenu, event) {
    $mdMenu.open(event);
  }
}

angular
  .module('bringoz.admin.webhooks')
  .component('webhooksTableRow', {
    bindings: {
      webhook: '<',
      webhookId: '<',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./webhooks-table-row.html').default,
    controller: webhooksTableRowController
  });
